<template>
  <div>
    <div class="container-fluid" v-if="loading">
      <div class="section-body margin-top-50">
        <LoadingAnimation :show-message="true"/>
      </div>
    </div>

    <div v-if="!loading">
      <div class="form login-form">
        <div class="row" :class="form.errors.has('internalError') ? ' has-error' : ''">
          <div class="col-md-12 form-group margin-bottom-30">
            <span class="black-title margin-0">Log in</span>
            <span class="help-block" v-if="form.errors.has('internalError')">
                <strong>Something went wrong. Please try again later.</strong>
              </span>
          </div>
        </div>

        <div class="row form-group margin-bottom-30" :class="form.errors.has('email') ? ' has-error' : ''">
          <label for="email" class="col-md-4 control-label input-label">E-Mail Address</label>
          <div class="col-md-12">
            <input id="email" type="email" class="form-control email-placeholder" required autofocus
                   placeholder="Email address" v-model="form.email" label="email">
            <span class="help-block" v-if="form.errors.has('email')">
                <strong>{{ form.errors.get('email') }}</strong>
              </span>
          </div>
        </div>

        <div class="row form-group margin-bottom-30" :class="form.errors.has('password') ? ' has-error' : ''">
          <label for="password" class="col-md-4 control-label input-label">Password</label>
          <div class="col-md-12">
            <input id="password" type="password" class="form-control password-placeholder" required
                   placeholder="Enter password" v-model="form.password" label="password">
            <span class="help-block" v-if="form.errors.has('password')">
                <strong>{{ form.errors.get('password') }}</strong>
              </span>
          </div>
        </div>

        <div class="row form-group margin-bottom-30">
          <div class="col-md-6">
            <div>
              <label class="input-label">
                <input type="checkbox" v-model="form.rememberMe" label="Remember me checkbox"> Remember Me
              </label>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <button type="submit" class="width-100 btn hh-btn hh-btn-green login-btn" @click="submit" name="Login"
                    :disabled="loading">
              Login
            </button>
          </div>
        </div>

        <div class="row hh-cta-link margin-bottom-15">
          <div class="col-md-12 no-padding text-center">
            <a class="cta-link" href="/password/reset">
              Forgot Your Password?
            </a>
          </div>
        </div>

        <div class="row hh-cta-link form" v-if="canSwitchForms">
          <div class="col-md-12 no-padding text-center">
            <p class="" @click="switchForms">
              Don't have an account? <a class="cta-link ">Register here</a>
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

import Form from '../../plugins/hh-form.js'
import LoadingAnimation from '../../components/LoadingAnimation'

export default {
  name: "LoginModal",
  components: {
    LoadingAnimation,
  },

  props: {
    canSwitchForms: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
      loading: false,
      form: new Form({
        email: null,
        password: null,
        rememberMe: null,
      }, this.$api),
    }
  },

  methods: {
    ...mapActions('auth', ['login']),

    async submit() {
      this.loading = true

      await this.login(this.form)

      if (this.form.errors.any()) {
        this.loading = false
        return false
      }

      this.$emit('complete')
      this.loading = false
    },

    switchForms() {
      this.$emit('switchForms')
    },
  }
}
</script>

<style lang="scss" scoped>

</style>